var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomOrganization = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.462 5-.001.775 3.077.001v18.022H4.231V5.776l3.076-.001V5h6.155zM9.769 17.791H6.077v3.604h3.692v-3.604zm4.923 0H11v3.604h3.692v-3.604zM9.77 12.985H6.077v3.604h3.692v-3.604zm4.923 0H11v3.604h3.692v-3.604zM9.77 8.179H6.077v3.604h3.692V8.18zm4.923 0H11v3.604h3.692V8.18z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.308 8.617v.538h2.461v14.643h-8.923V9.155h1.538v-.538h4.924zm-2.954 10.3H17.4v2.929h2.954v-2.929zm3.938 0H21.34v2.929h2.953v-2.929zm-3.938-3.905H17.4v2.93h2.954v-2.93zm3.938 0H21.34v2.93h2.953v-2.93zm-3.938-3.904H17.4v2.928h2.954v-2.928zm3.938 0H21.34v2.928h2.953v-2.928z",
    fill: "#8CBAC7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M3 23.798h24V25H3z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomOrganization);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-organization.0c723c464500588c483387c6832ea413.svg";